module.exports = __webpack_public_path__ + "static/media/freedom-soup.c5e38817.jpg";